import type { Meta } from '@brighterly/lib-core-types/api/interfaces'
import type { Subscription, SubscriptionModal, SubscriptionOrder } from '@entities/subscription'
import type { SubscriptionsStore } from './interfaces'

import { isFullArray } from '@shared/lib/collections'

const findSubscription = (state: SubscriptionsStore, subscriptionId: number | null | undefined): Subscription | null =>
  state.subscriptions.find(subscription => subscription.id === subscriptionId) ?? null

export const getters = {
  isLoading: (state: SubscriptionsStore): SubscriptionsStore['loading'] => state.loading,
  isProcessing: (state: SubscriptionsStore): boolean => state.processing > 0,
  getSubscriptions: (state: SubscriptionsStore): SubscriptionsStore['subscriptions'] => state.subscriptions,
  hasSubscriptions: (state: SubscriptionsStore): boolean => isFullArray(state.subscriptions),
  getMeta: (state: SubscriptionsStore): Meta | null => state.meta,
  getAgents: (state: SubscriptionsStore): SubscriptionsStore['agents'] => state.agents,
  getDiscounts: (state: SubscriptionsStore): SubscriptionsStore['discounts'] => state.discounts,
  getFilterSearch: (state: SubscriptionsStore): SubscriptionsStore['filterSearch'] => state.filterSearch,
  getFilterStatuses: (state: SubscriptionsStore): SubscriptionsStore['filterStatuses'] => state.filterStatuses,
  getFilterFrom: (state: SubscriptionsStore): SubscriptionsStore['filterFrom'] => state.filterFrom,
  getFilterTo: (state: SubscriptionsStore): SubscriptionsStore['filterTo'] => state.filterTo,
  getFilterCustomerId: (state: SubscriptionsStore): SubscriptionsStore['filterCustomerId'] => state.filterCustomerId,
  getCurrentPage: (state: SubscriptionsStore): SubscriptionsStore['currentPage'] => state.currentPage,
  getPerPage: (state: SubscriptionsStore): SubscriptionsStore['perPage'] => state.perPage,
  getExpandedId: (state: SubscriptionsStore): SubscriptionsStore['expandedId'] => state.expandedId,
  getActiveModal: (state: SubscriptionsStore): SubscriptionsStore['activeModal'] => state.activeModal,
  getModalSubscriptionId: (state: SubscriptionsStore): SubscriptionsStore['modalSubscriptionId'] => state.modalSubscriptionId,
  getModalSubscription: (state: SubscriptionsStore): Subscription | null => findSubscription(state, state.modalSubscriptionId),
  getRetrySubscription: (state: SubscriptionsStore): Subscription | null => findSubscription(state, state.retryTarget?.subscriptionId),
  getRetryOrder: (state: SubscriptionsStore): SubscriptionOrder | null =>
    findSubscription(state, state.retryTarget?.subscriptionId)?.orders
      .find(order => order.id === state.retryTarget?.orderId) ?? null,
  isModalOpen: (state: SubscriptionsStore) => (modal: SubscriptionModal): boolean =>
    state.activeModal === modal && findSubscription(state, state.modalSubscriptionId) !== null,
}
